import PropTypes from 'prop-types';
import React from 'react';
import i18n from 'i18next';
import { Modal, message, Button, Form, Radio, Input } from 'antd';
import { Checkbox, Row, Col, Select, Tree } from 'antd';
import { apis } from '../api/index.js';
const { Option } = Select;
const { TreeNode } = Tree;

class RoleAdd extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    visible: PropTypes.bool.isRequired,
    productList: PropTypes.array,
    menuList: PropTypes.array,
    menuLen: PropTypes.number,
    roleInfo: PropTypes.object,
    detailType: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    history: PropTypes.object,
  };

  state = {
    confirmLoading: false,
    status: 0,
    menuChecked: [],
    menuHalfChecked: [],
    operateChecked: [],
    checkboxSelectedValue: [],
    systemCheckboxValue: [],
    operateMenu: [
      {
        id: '1',
        menuName: '操作',
        childMenus: [
          { id: 'S', menuName: '信息脱敏', childMenus: [] },
          { id: 'V', menuName: '审核', childMenus: [] },
          { id: 'R', menuName: '高级审核', childMenus: [] },
          { id: 'E', menuName: '审核查看', childMenus: [] },
          { id: 'P', menuName: '报告查看', childMenus: [] },
          { id: 'Q', menuName: '报告申请', childMenus: [] },
          { id: 'M', menuName: '报告书写', childMenus: [] },
          { id: 'T', menuName: '报告审核', childMenus: [] }, //远程报告审核
          { id: 'T2', menuName: '三级审核', childMenus: [] }, //疑难病例审核
          { id: 'I', menuName: '打印报告', childMenus: [] },
          { id: 'A', menuName: 'AI报告查看', childMenus: [] },
          { id: 'V2', menuName: '智能筛查二审（内部使用）', childMenus: [] },
          { id: 'V3', menuName: '智能筛查三审（内部使用）', childMenus: [] },
        ],
      },
    ],
  };
  componentDidUpdate(prevProps) {
    const { visible } = this.props;
    if (prevProps.visible !== visible && visible) {
      let operateChecked = [];
      this.props.form.resetFields();
      const { roleInfo, detailType } = this.props;
      let menus = roleInfo.roleMenus || '',
        menuChecked = [],
        menuHalfChecked = [];
      if (detailType === 'detail' || detailType === 'update') {
        operateChecked = roleInfo.roleOperation
          ? roleInfo.roleOperation.split(',')
          : [];

        menus = menus ? menus.split(';') : [];
        if (menus.length === 2) {
          menuChecked = menus[1].split(',');
          menuHalfChecked = menus[0].split(',');
        } else menuChecked = menus[0] ? menus[0].split(',') : [];
      } else {
        operateChecked = [];
        menuChecked = [];
        menuHalfChecked = [];
      }
      //--end
      this.getSystemCheckboxValues([...menuHalfChecked, ...menuChecked]);
      const _this = this;
      setTimeout(function() {
        _this.setState({
          operateChecked,
          menuChecked,
          menuHalfChecked,
          checkboxSelectedValue: roleInfo.roleProduct,
        });
      }, 1);
    }
  }

  handleOk = e => {
    e.preventDefault();
    const { detailType, roleInfo } = this.props;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let { operateChecked, menuChecked, menuHalfChecked } = this.state;
        menuHalfChecked =
          menuHalfChecked.length > 0 ? menuHalfChecked.join(',') + ';' : '';
        menuChecked = menuChecked.join(',');
        if (operateChecked.indexOf('1') >= 0)
          operateChecked = operateChecked.slice(1);
        const post = {
          roleName: values.name,
          roleOperation: operateChecked.join(','),
          roleProduct: values.application.join(','),
          status: values.status,
          remark: values.remark,
          roleMenus: menuHalfChecked + menuChecked,
        };
        let apiUrl, apiMsg;
        if (detailType === 'update') {
          post.id = roleInfo.id;
          apiUrl = apis.modifyRoleInfo(post);
          apiMsg = '修改成功';
        } else {
          apiUrl = apis.addRoleInfo(post);
          apiMsg = '创建成功';
        }
        apiUrl.then(res => {
          if (res.code === '0') {
            message.success(apiMsg);
            this.handleCancel(true);
          } else {
            message.error(res.message);
            if (res.code === '1009') this.props.history.push('/login');
          }
        });
      }
    });
  };

  //点击“取消按钮”隐藏对话框
  handleCancel = changed => {
    this.props.onCancel(changed);
  };

  //菜单权限checked
  menuOnCheck = (checkedKeys, e) => {
    this.setState({
      menuChecked: checkedKeys,
      menuHalfChecked: e.halfCheckedKeys,
    });
  };

  //操作权限checked
  operateOnCheck = (checkedKeys, e) => {
    this.setState({ operateChecked: checkedKeys });
  };

  //菜单权限
  renderTreeNodes = (data, pid) => {
    const { detailType } = this.props;
    const { systemCheckboxValue, menuHalfChecked, menuChecked } = this.state;
    const { checkboxSelectedValue = [] } = this.state;
    if (detailType === 'detail') {
      return data.map(item => {
        if (item.pid === null) pid = item.id;

        if (item.childMenus.length > 0) {
          return (
            <TreeNode title={item.menuName} key={item.id} dataRef={item}>
              {this.renderTreeNodes(item.childMenus, pid)}
            </TreeNode>
          );
        }

        return <TreeNode key={item.id} title={item.menuName} />;
      });
    } else {
      return data.map(item => {
        if (item.pid === null) pid = item.id;

        let disabled = true;
        if (
          systemCheckboxValue.indexOf(pid + '') >= 0 &&
          detailType !== 'detail'
        )
          disabled = false;
        if (item.childMenus.length > 0) {
          if (menuChecked.length < this.props.menuLen) {
            const index = menuChecked.indexOf(JSON.stringify(item.id));
            if (index >= 0) {
              menuChecked.splice(index, 1);
              menuHalfChecked.push(item.id);
            }
          }
          return (
            <TreeNode
              disabled={disabled}
              title={item.menuName}
              key={item.id}
              dataRef={item}
            >
              {this.renderTreeNodes(item.childMenus, pid)}
            </TreeNode>
          );
        }

        /**如果是AI产品里的菜单则需要重新判断是否可选 */
        const productionIds = ['11', '9', '6', '8', '1001']; //AI产品
        const menuContent = item.menuContent.split('/');
        const productId = menuContent[menuContent.length - 1]; //当前菜单对应的产品id
        const isProduct = productionIds.indexOf(productId); //是否是AI产品
        const index = checkboxSelectedValue.indexOf(productId); //是否在所属应用栏被选中

        //如果是AI产品，但在所属应用中未被选中则在菜单中不可选
        if (!disabled) {
          if (isProduct >= 0 && index === -1) disabled = true;
          else disabled = false; //否则即不是AI产品或已被选中，在菜单中可选
        }
        if (disabled) {
          const index = menuChecked.indexOf(JSON.stringify(item.id));
          if (index >= 0) menuChecked.splice(index, 1);
        }
        /**end如果是AI产品里的菜单则需要重新判断是否可选 */

        return (
          <TreeNode disabled={disabled} key={item.id} title={item.menuName} />
        );
      });
    }
  };

  renderOperateTreeNodes = data => {
    return data.map(item => {
      if (item.childMenus.length > 0) {
        return (
          <TreeNode title={item.menuName} key={item.id}>
            {this.renderOperateTreeNodes(item.childMenus)}
          </TreeNode>
        );
      }

      return <TreeNode key={item.id} title={item.menuName} />;
    });
  };

  handleChange = value => {
    this.setState({ checkboxSelectedValue: value });
  };

  //获取应用列表checkbox
  getSystemCheckboxs = () => {
    const { menuList } = this.props;
    if (menuList) {
      const checkboxs = [];
      menuList.forEach(item => {
        if (item.menuType === '1') {
          checkboxs.push(
            <Checkbox key={item.id + ''} value={item.id + ''}>
              {item.menuName}
            </Checkbox>
          );
        }
      });
      return checkboxs;
    }
  };

  //获取应用列表已选中的值
  getSystemCheckboxValues = menuChecked => {
    const { menuList } = this.props;
    const [values, checked] = [[], []];
    menuList.forEach(item => {
      if (item.menuType === '1') values.push(item.id + '');
    });
    values.forEach(value => {
      if (menuChecked.indexOf(value) >= 0) checked.push(value);
    });
    this.setState({ systemCheckboxValue: checked });
  };

  systemCheckboxChanged = values => {
    this.setState({ systemCheckboxValue: values });
  };

  render() {
    const { confirmLoading } = this.state;
    const { operateMenu, systemCheckboxValue } = this.state;
    const { menuList, detailType, roleInfo, productList } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout1 = { labelCol: { span: 3 }, wrapperCol: { span: 21 } };
    let title = 'newRole';
    if (detailType === 'detail') title = 'viewRole';
    else if (detailType === 'update') title = 'updateRole';

    const buttons = [
      <Button
        key="cancel"
        onClick={this.handleCancel}
        type="default"
        className="btn-cancel"
      >
        取消
      </Button>,
    ];
    if (detailType !== 'detail')
      buttons.push(
        <Button
          key="submit"
          type="primary"
          loading={confirmLoading}
          onClick={this.handleOk}
          className="btn-ok"
        >
          确定
        </Button>
      );

    return (
      <div className="group-modal">
        <Modal
          title={i18n.t(title)}
          visible={this.props.visible}
          width={650}
          height={610}
          className="group-manager"
          onCancel={this.handleCancel}
          footer={buttons}
        >
          <div className="user-add-form">
            <Form {...formItemLayout1}>
              <Form.Item label={i18n.t('roleName')} hasFeedback>
                {getFieldDecorator('name', {
                  rules: [{ required: true }],
                  initialValue: roleInfo.roleName,
                })(<Input type="text" disabled={detailType === 'detail'} />)}
              </Form.Item>
              <Form.Item label={i18n.t('application')} hasFeedback>
                {getFieldDecorator('application', {
                  rules: [{ required: true }],
                  initialValue: roleInfo.roleProduct
                    ? roleInfo.roleProduct.split(',')
                    : [],
                })(
                  <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder={i18n.t('applicationPlaceholder')}
                    disabled={detailType === 'detail'}
                    onChange={this.handleChange}
                  >
                    {productList.map(item => (
                      <Option key={item.productId}>{item.productName}</Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label={i18n.t('status')}>
                {getFieldDecorator('status', {
                  initialValue: roleInfo.status || '1',
                })(
                  <Radio.Group
                    style={{ width: '100%' }}
                    disabled={detailType === 'detail'}
                  >
                    <Radio value="1">正常</Radio>
                    <Radio value="0">停用</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
              <Form.Item label={i18n.t('remark')} hasFeedback>
                {getFieldDecorator('remark', {
                  initialValue: roleInfo.remark,
                })(<Input disabled={detailType === 'detail'} />)}
              </Form.Item>
              <p>{i18n.t('角色权限配置')}</p>
              <Row className="role-manager-setting">
                <Col span={8}>
                  <p className="title">应用列表</p>
                  <Checkbox.Group
                    onChange={this.systemCheckboxChanged}
                    defaultValue={systemCheckboxValue}
                    value={systemCheckboxValue}
                    disabled={detailType === 'detail'}
                  >
                    {this.getSystemCheckboxs()}
                  </Checkbox.Group>
                </Col>
                <Col span={8}>
                  <p className="title">菜单权限</p>
                  <Tree
                    checkable
                    onCheck={this.menuOnCheck}
                    checkedKeys={this.state.menuChecked}
                    defaultExpandAll={true}
                    disabled={detailType === 'detail'}
                  >
                    {this.renderTreeNodes(menuList)}
                  </Tree>
                </Col>
                <Col span={8}>
                  <p className="title">操作权限</p>
                  <Tree
                    checkable
                    disabled={detailType === 'detail'}
                    onCheck={this.operateOnCheck}
                    checkedKeys={this.state.operateChecked}
                    defaultExpandAll={true}
                  >
                    {this.renderOperateTreeNodes(operateMenu)}
                  </Tree>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Form.create()(RoleAdd);
